import { autoinject } from 'aurelia-dependency-injection';
import { enumToArray } from './enum-to-array';
import { EnumAndTypesClient } from '../clients/transaction-clients';
import { CustomerService } from './customer-service';
import { CompaniesClient, InstrumentType } from '../clients/policy-clients';
import { CacheService } from './cache-service';

@autoinject
export class InstrumentTypesCache {
  constructor(private enumAndTypesClient: EnumAndTypesClient, private customerService: CustomerService, private companiesClient: CompaniesClient, private cacheService: CacheService) { }

  get customerInstrumentTypes() {
    return this.cacheService.getOrSet(`customer-instrument-types-${this.customerService.selectedCustomer.companyId}`,
      () => this.companiesClient.instrumentTypes(this.customerService.selectedCustomer.companyId).then(x => x ?? enumToArray(InstrumentType)), 6000000000);
  }

  get instrumentTypes() {
    return this.cacheService.getOrSet(
        `instrument-types-${this.customerService.selectedCustomer.companyId}`,
        () => this.enumAndTypesClient.getInstrumentTypes(this.customerService.selectedCustomer.companyId),
        6000000000
    );
  }
  

}
